// @flow
import { connect } from 'react-redux';
import FriendInvitation from './FriendInvitation';
import type { StateProps } from './FriendInvitation';
import type { StateType } from '../../../modules/reducers';
import { isLoadingSelector } from '../../../modules/LoadingStatus/reducer';
import { fetchReferralBonuses, referralBonusesSelector } from '../../../modules/Bonuses';
import {
  godfatherValidityErrorSelector,
  isGodfatherValid,
  verifyGodfather,
  setGodfatherExternalId,
} from '../../../modules/SignUp/Bonus';

const mapStateToProps = (state: StateType): StateProps => ({
  godfatherValidityError: godfatherValidityErrorSelector(state),
  isGodfatherInvalid: !isGodfatherValid(state),
  isInitializing: isLoadingSelector(state, 'fetchReferralBonuses') || isLoadingSelector(state, 'verifyGodfather'),
  referralBonuses: referralBonusesSelector(state),
});

const mapDispatchToProps = {
  setGodfatherExternalId,
  verifyGodfather,
  fetchReferralBonuses,
};

export default connect(mapStateToProps, mapDispatchToProps)(FriendInvitation);
